import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllScraps } from "../../../redux/action/scraps";
import { useQuery } from "../../../helpers/helper";
import SelectNetworkOptions from "./SelectNetworkOptions";
import PersonalNetwork from "./PersonalNetwork";
import ExternalNetwork from "./ExternalNetwork";
import { ClipLoader } from "react-spinners";

const Step5 = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const networkType = query.get("network");
  const { loading } = useSelector((state) => state.organization);

  useEffect(() => {
    dispatch(getAllScraps());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex grey lighten-4">
        <div className="container  first-time-container flex column align-center space-between">
          <div className="dialogue-box">
            <ClipLoader color="#000" loading={loading} />
            <p>Loading</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex grey lighten-4">
      {!networkType && <SelectNetworkOptions />}
      {networkType === "personal" && <PersonalNetwork />}
      {networkType === "external" && <ExternalNetwork />}
    </div>
  );
};

export default Step5;
